import Component from "@glimmer/component"
import type SchoolYear from "@shared/models/school-year"
import FindDoc from "cc-frontend/helpers/find-doc"
import { use } from "ember-could-get-used-to-this"

interface Sig {
  Args: {
    schoolYearId: string
  }
  Blocks: {
    default?: [model: FindDoc<"school-year", SchoolYear>]
  }
}

export default class SchoolYearProviderComponent extends Component<Sig> {
  @use model = new FindDoc(() => ["school-year", this.args.schoolYearId])
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    SchoolYearProvider: typeof SchoolYearProviderComponent
  }
}
